import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {LAZY_SCRIPT_NAME, LazyScriptLoaderService} from '@utils/services/lazy-script-loader/lazy-script-loader.service';
import {isPlatformServer} from '@angular/common';

declare let twttr: any;
declare let FB: any;
declare let instgrm: any;

@Component({
  selector: 'lib-news-text',
  template: '',
  styleUrls: ['./news-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewsTextComponent implements OnInit, OnChanges {

  @Input() private text: string;
  @Input() private loadEmbeds = false;
  @Output() private textRender = new EventEmitter<HTMLElement>();
  private facebookParsed = false;
  private instagramParsed = false;
  private twitterParsed = false;

  constructor( private elementRef: ElementRef,
               private lazyScriptLoader: LazyScriptLoaderService,
               @Inject(PLATFORM_ID) private platformId: object ) {}

  public ngOnInit(): void {
    this.parseSocialMediaEmbeds();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadEmbeds) {
      this.parseSocialMediaEmbeds();
    }
    if (changes.text) {
      this.updateText();
      this.parseSocialMediaEmbeds();
    }
  }

  private async parseSocialMediaEmbeds(): Promise<void> {
    const element = this.elementRef?.nativeElement as HTMLElement;
    if (!element || !this.loadEmbeds || isPlatformServer(this.platformId)) {
      return;
    }
    const facebookEmbeds = element.getElementsByClassName('news-embed-social-facebook');
    const instagramEmbeds = element.getElementsByClassName('news-embed-social-instagram');
    const twitterEmbeds = element.getElementsByClassName('news-embed-social-twitter');
    if (facebookEmbeds?.length && !this.facebookParsed) {
      this.lazyScriptLoader.load(LAZY_SCRIPT_NAME.FACEBOOK_SDK).then(() => {
        if (typeof FB !== 'undefined') {
          FB.XFBML.parse();
          this.facebookParsed = true;
        }
      });
    }
    if (instagramEmbeds?.length && !this.instagramParsed) {
      this.lazyScriptLoader.load(LAZY_SCRIPT_NAME.INSTAGRAM_SDK).then(() => {
        if (typeof instgrm !== 'undefined') {
          instgrm.Embeds.process();
          this.instagramParsed = true;
        }
      });
    }
    if (twitterEmbeds?.length && !this.twitterParsed) {
      this.lazyScriptLoader.load(LAZY_SCRIPT_NAME.TWITTER_SDK).then(() => {
        if (typeof twttr !== 'undefined') {
          twttr.widgets.load();
          this.twitterParsed = true;
        }
      });
    }
  }

  private updateText(): void {
    const element = this.elementRef?.nativeElement as HTMLElement;
    if (!element) {
      return;
    }
    this.text = this.text.replace(/<style>(\n|\r|\n\r|.)*<\/style>/g, "");
    element.innerHTML = this.text;
    if (!isPlatformServer(this.platformId)) {
      setTimeout(() => this.textRender.emit(element), 0);
    }
  }


}
